import type { ReceiptTemplate } from '../schema';

export const goCardlessTemplate: ReceiptTemplate = {
  id: 'gocardless',
  name: 'GoCardless Receipt',
  brand: 'GOCARDLESS',
  description: 'GoCardless direct debit receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '£',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'gcl-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'GOCARDLESS',
        businessNameFontSize: 16,
        addressLines: ['DIRECT DEBIT RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'gcl-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'payment', label: 'Payment ID:', value: 'PM-847291034' },
          { id: 'merchant', label: 'To:', value: 'ACME SERVICES LTD' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'mandate', label: 'Mandate:', value: 'MD-4892' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'gcl-amount',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'amount', label: 'AMOUNT', value: '49.99', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'gcl-account',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'ACCOUNT: ****4892\nSTATUS: CONFIRMED\nTYPE: RECURRING', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'gcl-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'PAYMENT SUCCESSFUL', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: true },
    },
  ],
  updatedAt: new Date().toISOString(),
};

